import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from 'redux';
import { TradeList, TradeDetail } from './components';
import { TradeActions, NotificationActions } from '../../store';

const style = theme => ({
    root: {
        height: '100%'
    },
    visibleList: {
        height: '100%',
        visibility: 'visible'
    },
    hiddenList: {
        height: '100%',
        visibility: 'hidden'
    }
})

const IdentitySelector = (state) => state.Identity;

const Trade = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    // アクションを取得
    const tradeActions = bindActionCreators(TradeActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    // トークンID, ユーザ情報を取得
    const { token, userData } = useSelector(IdentitySelector);

    // 画面モードと併せて、取消フラグ、一覧画面のフィルタリング情報も保持
    const [modeInfo, setModeInfo] = useState({
        mode: 'list'
        , cancel_flag: false
        , transaction_dt: '', merchant_name: '', merchant_type: '', shop_name: '', transaction_type: '', credit_account_type: '', payment_no: '', terminal_id: '', credit_amount: ''
    });
    const [listRefresh, setListRefresh] = useState(true);

    // props引数パラメータを取得
    const { classes } = props;

    /**
     *
     * 詳細画面表示
     *
     * @param dtl 選択された行のデータ
     */
    const showDetail = (dtl, transactionDt, merchantName, merchantType, shopName, transactionType, creditAccountType, paymentNo, terminalId, creditAmount) => {
        // 対象の取引IDの取引情報を取得
        tradeActions.loadEditModel(token, dtl.id)
            .then(data => {
                // 対象の取引IDが取り消されているかを取得
                tradeActions.IsCancelTrade(token, dtl.id)
                    .then(cancel => {
                        // 詳細画面に表示切替
                        setModeInfo({
                            mode: 'detail'
                            , cancel_flag: cancel
                            , transaction_dt: transactionDt
                            , merchant_name: merchantName
                            , merchant_type: merchantType
                            , shop_name: shopName
                            , transaction_type: transactionType
                            , credit_account_type: creditAccountType
                            , payment_no: paymentNo
                            , terminal_id: terminalId
                            , credit_amount: creditAmount
                        });
                    })
                    .catch(e => {
                        notificationActions.showError(e.message);
                    });
            })
            .catch(e => {
                notificationActions.showError('取引情報を取得できませんでした。');
            });
    }

    /**
     *
     * リスト画面表示
     *
     */
    const showList = () => {
        setListRefresh(false);
        setModeInfo({
            mode: 'list'
            , cancel_flag: modeInfo.cancel_flag
            , transaction_dt: modeInfo.transaction_dt
            , merchant_name: modeInfo.merchant_name
            , merchant_type: modeInfo.merchant_type
            , shop_name: modeInfo.shop_name
            , transaction_type: modeInfo.transaction_type
            , credit_account_type: modeInfo.credit_account_type
            , payment_no: modeInfo.payment_no
            , terminal_id: modeInfo.terminal_id
            , credit_amount: modeInfo.credit_amount
        });
    }

    var listClass = classes.hiddenList;
    if (modeInfo.mode == 'list') {
        // 取引一覧を表示するCSS設定
        listClass = classes.visibleList;
    }

    var content = <div></div>;
    if (modeInfo.mode == 'detail') {
        // 参照画面表示
        // 詳細画面用に戻るボタン（一覧画面）用のデリゲートを設定
        content = <TradeDetail onCancel={showList} cancelFlag={modeInfo.cancel_flag} />
    }

    return (
        <div className={classes.root} maxWidth={false}>
            {content}
            <div className={listClass}>
                <TradeList onDetail={showDetail} refresh={listRefresh}
                    //transactionDt={modeInfo.transaction_dt}
                    //merchantName={modeInfo.merchant_name}
                    //merchantType={modeInfo.merchant_type}
                    //shopName={modeInfo.shop_name}
                    //transactionType={modeInfo.transaction_type}
                    //creditAccountType={modeInfo.credit_account_type}
                    //paymentNo={modeInfo.payment_no}
                    //terminalId={modeInfo.terminal_id}
                    //creditAmount={modeInfo.credit_amount}
                />
            </div>
        </div>
    )
}

export default withStyles(style, { withTheme: true })(Trade);
